import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUserFromStorage } from '../services/auth';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const user = getUserFromStorage();
  if (!user) {
    return <Navigate to="/" replace />;
  }
  if (!allowedRoles.includes(user.role)) {
    // Usuario no autorizado para esta ruta
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
